<template>
  <aside class="cn-trade-panel" aria-label="A股交易" tabindex="-1">
    <ChinaStockTrade :symbol="symbol" drawer>
      <template #heading-actions="{ stockName, contractId }"><TradeHeaderActions :symbol="symbol" :name="stockName" :contract-id="contractId" @close="$emit('close')" /></template>
    </ChinaStockTrade>
  </aside>
</template>
<script>
import ChinaStockTrade from '@/views/stock/china/ChinaStockTrade.vue'
import TradeHeaderActions from './TradeHeaderActions.vue'
export default {
  name: 'ChinaTradePanel',
  components: { ChinaStockTrade, TradeHeaderActions },
  props: { symbol: { type: String, required: true } }
}
</script>
<style scoped>
.cn-trade-panel { position: fixed; z-index: 2000; top: 64px; right: 0; width: 400px; max-width: calc(100vw - 60px); height: calc(100vh - 64px); overflow-y: auto; overscroll-behavior: contain; background: var(--theme-bg); color: var(--theme-label); font-size: 14px; box-shadow: -4px 0 12px #0004; }
.cn-trade-panel { box-sizing: border-box; border: 2px solid transparent; }
.cn-trade-panel:focus, .cn-trade-panel:focus-within { outline: none; border-color: var(--theme-accent); }
::v-deep .trading-panel { position: static; width: 100%; max-height: none; overflow: visible; }
::v-deep .right-wrap { width: 100%; }
::v-deep .stock-data-panel > .title_jy_box:first-child { padding-right: 8px; }
::v-deep .jy_input_box { display: grid; grid-template-columns: 80px minmax(0, 1fr) auto; align-items: center; gap: 8px; padding: 10px; border-color: var(--theme-border); cursor: default; }
::v-deep .jy_input_box > div { min-width: 0; }
::v-deep .jy_input_box > div:last-child { gap: 8px; }
::v-deep .jy_input_box .el-input { width: 100%; min-width: 0; }
::v-deep .jy_input_box .el-input__inner { height: 32px; line-height: 32px; padding: 0 10px; font: inherit; }
::v-deep .jy_add_btns { flex: 0 0 32px; width: 32px; height: 32px; line-height: 30px; margin: 0 !important; cursor: pointer; }
::v-deep .jy_d_bt_boxs { gap: 8px; flex-wrap: wrap; height: auto; min-height: 28px; }
::v-deep .jy_gp_boxs { flex: 1; min-width: 0; width: auto; border-color: var(--theme-border); }
::v-deep .jy_gp_boxs_active { border-color: var(--theme-accent); color: var(--theme-accent); }
</style>
